import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=ef76aaea&scoped=true"
import script from "./FormButtons.vue?vue&type=script&lang=js"
export * from "./FormButtons.vue?vue&type=script&lang=js"
import style0 from "./FormButtons.vue?vue&type=style&index=0&id=ef76aaea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef76aaea",
  null
  
)

export default component.exports